import React from "react";
import { withStyles } from "@material-ui/core";
import AddRoundedIcon from "@material-ui/icons/AddRounded";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import EditIcon from "@material-ui/icons/Edit";
import Tooltip from "../../../../../common/StyledToolTip";
import SearchBox from "../../../../../common/SearchBox";
import ClearAllFilterButton from '@dataGrid/components/columnFilters/ClearAllFilterButton';

const styles = (theme) => ({
  headerStyle: {
    margin: "5px 0px",
    height: "30px",
    borderRadius: "4px 4px 0 0",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  headerLabel: {
    color: theme.HeaderSelectedText,
    fontSize: "14px",
    fontWeight: 600,
  },
  headerIconStyles: {
    padding: "5px 10px",
    borderLeft: `1px solid ${theme.AppBGColor}`,
    color: theme.iconColor,
  },
  disableIcon: {
    cursor: "not-allowed",
    opacity: 0.7,
  },
  enableIcon: {
    cursor: "pointer",
  },
  iconLayout: {
    color: theme.iconColor,
    "&>span": {
      padding: "10px 10px",
      color: theme.iconColor,
    },
  },
  searchBoxContainer: {
    display: 'flex',
    alignItems: 'center'
  }
});

const DriverPreferencesGridHeader = ({
  classes,
  gridApi,
  selectedDriverPreferences,
  onDriverPreferenceFormOpen,
  isDriverPreferenceFromOpen,
  updateQuickFilterText,
  onDeleteDriverPreference,
}) => {
  const getIconTitle = (params) => {
    const {
      iconName,
      isDriverPreferenceFromOpen,
      disableUpdateIcon,
      disableAddIcon,
    } = params;
    if (isDriverPreferenceFromOpen) {
      return "Add/update in progress";
    }
    switch (iconName) {
      case "editIcon":
        if (!disableUpdateIcon) {
          return "Click to edit";
        } else {
          return "Select a row to edit";
        }
      case "deleteIcon":
        if (!disableUpdateIcon) {
          return "Click to delete";
        } else {
          return "Select a row to delete";
        }
      case "addIcon":
        return disableAddIcon ? "Disabled" : "Click to add";
      default:
        return "";
    }
  };

  const getButtonStyle = (disableIcon) => {
    return `${classes.headerIconStyles} ${classes.iconLayout}  ${
      disableIcon ? classes.disableIcon : classes.enableIcon
    }`;
  };

  const disableAddIcon = isDriverPreferenceFromOpen;

  const disableUpdateIcon =
    !selectedDriverPreferences?.length ||
    isDriverPreferenceFromOpen ||
    selectedDriverPreferences.length > 1;
  const params = {
    isDriverPreferenceFromOpen,
    disableUpdateIcon,
    disableAddIcon,
  };
  const handleDeleteDriverPreference = () => {
    if (!disableUpdateIcon) {
      onDeleteDriverPreference(selectedDriverPreferences[0]);
    }
  };

  const handleEditDriverPreference = () => {
    if (!disableUpdateIcon) {
      onDriverPreferenceFormOpen(
        selectedDriverPreferences,
        selectedDriverPreferences[0]
      );
    }
  };

  const handleAddDriverPreference = () => {
    if (!disableAddIcon) {
      onDriverPreferenceFormOpen([], null);
    }
  };

  return (
    <div className={classes.headerStyle}>
      <div>
        <span
          className={classes.headerLabel}
          data-automationid="DriverPreferences-title"
        >
          Driver Preferences
        </span>
      </div>
      <div className={classes.searchBoxContainer}>
        <span>
          <SearchBox onChange={updateQuickFilterText} />
          <ClearAllFilterButton gridApi={gridApi} />
        </span>

        <span
          className={getButtonStyle(disableUpdateIcon)}
          onClick={handleDeleteDriverPreference}
        >
          <Tooltip title={getIconTitle({ iconName: "deleteIcon", ...params })}>
            <DeleteOutlineIcon />
          </Tooltip>
        </span>

        <span
          className={getButtonStyle(disableUpdateIcon)}
          onClick={handleEditDriverPreference}
        >
          <Tooltip title={getIconTitle({ iconName: "editIcon", ...params })}>
            <EditIcon />
          </Tooltip>
        </span>

        <span
          className={getButtonStyle(disableAddIcon)}
          onClick={handleAddDriverPreference}
        >
          <Tooltip title={getIconTitle({ iconName: "addIcon", ...params })}>
            <AddRoundedIcon />
          </Tooltip>
        </span>
      </div>
    </div>
  );
};
export default withStyles(styles)(DriverPreferencesGridHeader);
